import React, {useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import SmartMeterPB from './smart-meterPB';
import CommandsContext from '../../../context/commandsContext';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function RunVerification({onExit}) {
  const runVerificationItem = [
    {id: 1, name: 'Continue Measuring', component: <SmartMeterPB />},
    {id: 2, name: 'Fix at Last Measured Value', component: <SmartMeterPB />},
    {id: 3, name: 'Fix at Fault', component: <SmartMeterPB />},
  ];

  const {selected, onComponent} = useMenu();
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  const {t, i18n} = useTranslation();
    const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <SubMenuView
        title={t('smvRunVerif.title')}
        menuItems={runVerificationItem}
        content={t('smvRunVerif.a8')}
        onLeftCallback={() => onExit()}
      />
    </>
  );
}

export default RunVerification;
